import { createContext, useContext, useEffect, useState } from 'react'

import { useUserResources } from 'shared/hooks'

const SignUpContext = createContext()

const SignupContextProvider = ({ children, isCaptchaEnabled, captchaKey }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const { userControls, isLoadingResources } = useUserResources()

  useEffect(() => {
    if (!isLoadingResources) {
      setIsLoggedIn(userControls.isLoggedIn)
    }
  }, [isLoadingResources, userControls.isLoggedIn])

  return (
    <SignUpContext.Provider
      value={{ isLoggedIn, setIsLoggedIn, isCaptchaEnabled, captchaKey }}
    >
      {children}
    </SignUpContext.Provider>
  )
}

const useSignupContext = () => {
  const context = useContext(SignUpContext)

  if (!context) {
    throw new Error(
      'useSignupContext must be used within an SignupContextProvider'
    )
  }

  return context
}

export { SignupContextProvider, useSignupContext }
